export default {
  container: {
    mt: '1rem',
  },
  spinnerContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '60vh',
  },
  menuContainer: {
    flexDirection: 'column',
    flex: 1,
    justifyContent: 'flex-start',
    maxWidth: '880px',
  },
  card: {
    justifyContent: 'center',
    alignItems: 'flex-start',
  },
  emptyText: {
    textAlign: 'center',
  },
  visitsScroll: {
    flexDirection: 'column',
    flex: '1 1 auto',
    overflowY: 'auto',
  },
  buttonContainer: {
    flex: 1,
    flexDirection: 'column',
    m: '5px',
    justifyContent: 'center',
    alignItems: 'center',
  },
  refreshButtonContainer: {
    mb: '5px',
  },
  manualRefreshButton: {
    flex: 1,
    flexDirection: 'column',
    m: '5px',
    alignItems: 'center',
  },
  containerFlatList: {
    flex: 1,
    flexDirection: 'column',
  },
};
